import { Component } from "react";
require("./overlay.css");
export class Overlay extends Component<{
  isMenuOverlay: boolean;
  isDialogOverlay?: boolean;
  closeModal?: () => void;
}> {
  state = {
    type: this.props.isMenuOverlay
      ? "menuOverlay"
      : this.props.isDialogOverlay
      ? "dialogOverlay"
      : "loaderOverlay",
  };
  render() {
    return (
      <div
        className={["overlayCommon", this.state.type].join(" ")}
        onClick={() => (this.props.closeModal ? this.props.closeModal() : null)}
      >
        {this.props.children}
      </div>
    );
  }
}
